import {CommonService} from '../../services/common.service';
import {Component, Inject, OnInit} from '@angular/core';
import {CreateDialogComponent} from '../create-dialog/create-dialog.component';
import {MAT_DIALOG_DATA, MatDialog, MatTableDataSource} from '@angular/material';
import {SimpleConfirmActionDialogComponent} from '../../common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {ToastMessagesService} from '../../services/toast-messages.service';

interface Option {
  id: number;
  description: string;
}

@Component({
  templateUrl: './options-dialog.component.html'
})
export class OptionsDialogComponent implements OnInit {
  basicDetailsConfig: any;
  showBasicInfo = false;
  user: any;
  loading: boolean;
  displayColumns = ['description', 'actions'];
  options: MatTableDataSource<Option> = new MatTableDataSource<Option>();

  constructor(private commonService: CommonService,
              private matDialog: MatDialog,
              private toastMessagesService: ToastMessagesService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.user = data.user;
    this.loading = false;
  }

  public async ngOnInit(): Promise<any> {
    await this.initBasicInfo();
    await this.initOptions();
  }

  async initOptions() {
    try {
      this.loading = true;
      this.options.data = [];
      const result = await this.commonService.getList('questionnaire/option') as Option[];
      this.options = new MatTableDataSource<Option>(result);
    } catch (e) {
      this.toastMessagesService.toastErrorMessage(e.message);
    } finally {
      this.loading = false;
    }
  }

  private async initBasicInfo() {
    this.basicDetailsConfig = {
      subtitle: [{
        title: 'Ενέργειες επιλογών',
        value: ''
      }],
      title: 'Επιλογές Απάντησης'
    };

    await this.initializeActions();
  }

  private async initializeActions() {
    const actions = [];

    const action2 = {
      function: () => {
        this.showCreateDialog();
      },
      showAction: true,
      title: 'Προσθήκη απάντησης',
      icon: 'add',
      color: '#013e81',
    };

    actions.push(action2);

    if (actions.length > 0) {
      this.basicDetailsConfig.actions = actions;
      this.basicDetailsConfig.showActions = true;
    } else {
      this.basicDetailsConfig.showActions = false;
    }
    this.showBasicInfo = true;
  }

  search($event: any) {
    this.options.filter = $event.target.value.trim().toLowerCase();
  }

  private showCreateDialog() {
    const createDialog = this.matDialog.open(CreateDialogComponent, {
      width: '550px',
      height: '150',
      data: {
        title: 'Δημιουργία απάντησης',
        mode: 0,
        type: 0
      }
    });

    createDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.insertItem(`questionnaire/option`, {description: result});
          this.toastMessagesService.toastMessages('Η επιλογή απάντησης δημιουργήθηκε με επιτυχία');
          await this.initOptions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  showUpdateDialog(option) {
    const createDialog = this.matDialog.open(CreateDialogComponent, {
      width: '550px',
      height: '150',
      data: {
        title: 'Ενημέρωση επιλογής απάντησης',
        mode: 1,
        type: 0,
        inputData: option.description
      }
    });

    createDialog.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          option.description = result;
          await this.commonService.updateObject(`questionnaire/option`, option);
          this.toastMessagesService.toastMessages('Η επιλογή απάντησης δημιουργήθηκε με επιτυχία');
          await this.initOptions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }

  deleteQuestion(element) {
    const confirm = this.matDialog.open(SimpleConfirmActionDialogComponent, {
      data: {
        title: 'Διαγραφή Απάντησης',
        message: 'Είστε σίγουροι ότι θέλετε να διαγράψετε την επιλογή απάντησης?'
      }
    });

    confirm.afterClosed().subscribe(async (result) => {
      if (result) {
        try {
          await this.commonService.deleteItem(`questionnaire/option`, element.id);
          this.toastMessagesService.toastMessages('Η διαγραφή ολοκληρώθηκε με επιτυχία');
          await this.initOptions();
        } catch (e) {
          this.toastMessagesService.toastErrorMessage(e.message);
        }
      }
    });
  }
}
